@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.action-menu-wrapper {
  .danger {
    color: @settings-page--templates-emails-action-menu--error--text-color;
  }
}

.actions-dropdown {
  background-color: @settings-page--templates-emails-action-dropdown--background-color;
  border: none;
  height: 100%;

  &:hover {
    background-color: @settings-page--templates-emails-action-dropdown--hover--background-color;
  }
}

.icon-wrapper {
  color: @settings-page--templates-emails-icon--text-color;
  cursor: pointer;

  &:hover {
    color: @settings-page--templates-emails-icon--hover--text-color;
  }

  svg {
    width: 16px;
  }
}

.icon-open {
  .icon-wrapper {
    color: @settings-page--templates-emails-icon-open--text-color;
    cursor: pointer;

    &:hover {
      color: @settings-page--templates-emails-icon--hover--text-color;
    }
  }
}
